import styled from "styled-components";

const MyDiv = styled.div`
  th, td {
    padding: 8px 12px;
    vertical-align: middle;
  }
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    gap: 8px;
  }

  .pagination li {
    background-color: transparent;
  }

  .pagination li a {
    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 31px;
    padding: 0 10px;

    height: 25px;
    white-space: nowrap;

    font-size: 14px;
    color: #3c3c4399;
    font-weight: 500;
    font-family: "Poppins", sans-serif;

    background-color: #fff;
    border-radius: 6px;
    transition: all 0.2s ease-in-out;
}

  .pagination li.active a {
    background-color: rgba(234, 236, 240, 1);
  }

  .pagination li.previous a,
  .pagination li.next a {
    font-size: 14px;
    color: #000;
    font-weight: 500;
    width: auto;
    height: auto;
    border: none;
    background-color: transparent;
  }

  .pagination li.disabled a {
    color: #ccc;
    cursor: not-allowed;
    border-color: #ccc;
  }

  .icon_btn {
   min-width: 40px;
    cursor: pointer;  
  }
@keyframes blinkOrange {
  0% { background: #EA580C; }
  50% { background: #C2410C; }
  100% { background: #EA580C; }
}

@keyframes blinkRed {
  0% { background: #EF4444; }
  50% { background: #B91C1C; }
  100% { background: #EF4444; }
}

@keyframes blinkBlue {
  0% { background: #2563EB; }
  50% { background: #1D4ED8; }
  100% { background: #2563EB; }
}

.blink-orange td {
  animation: blinkOrange 1s infinite;
  color: white !important;
}

.blink-red td {
  animation: blinkRed 1s infinite;
  color: white !important;
}

.blink-blue td {
  animation: blinkBlue 1s infinite;
  color: white !important;
}
  
`;

export default MyDiv;
